import ImageBlcok1Banner1 from "assets/block-1/1.jpg";
import ImageBlock2Product1 from "assets/block-2/1.jpg";
import ImageBlock2Product2 from "assets/block-2/2.jpg";
import ImageBlock2Product3 from "assets/block-2/3.jpg";
import ImageBlock2Product4 from "assets/block-2/4.jpg";
import ImageBlock3Bg from "assets/block-3.jpg";
import ImageBlock4Bg1 from "assets/block-4/1.jpg";
import ImageBlock4Bg2 from "assets/block-4/2.jpg";
import ImageBlock4Bg3 from "assets/block-4/3.jpg";
import ImageBlock5Bg from "assets/block-5.jpg";
import ImageBlock6Bg from "assets/block-6.jpg";
import ImageBlock7Bg from "assets/block-7.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "./index.scss";
import SwiperCore, {
  Autoplay,
  Mousewheel,
  Navigation,
  Pagination,
} from "swiper";

SwiperCore.use([Pagination, Navigation, Autoplay, Mousewheel]);

export const HomePage = () => {
  return (
    <div className="home-page-container">
      <div className="block-1">
        <Swiper>
          <SwiperSlide>
            <div
              className="content"
              style={{ backgroundImage: `url(${ImageBlcok1Banner1})` }}
            ></div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="content"
              style={{ backgroundImage: `url(${ImageBlcok1Banner1})` }}
            ></div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="content"
              style={{ backgroundImage: `url(${ImageBlcok1Banner1})` }}
            ></div>
          </SwiperSlide>
        </Swiper>
      </div>

      <div className="main-content">
        <div className="block block-2">
          <h3 className="title">星选臻品</h3>
          <p className="sub-title">应对多种头皮头发问题</p>
          <Swiper
            loop={true}
            autoHeight={true}
            slidesPerView={3}
            centeredSlides={true}
            watchSlidesProgress={true}
            mousewheel={true}
            onInit={(swiper) => {
              const slides = swiper.slides as any;
              for (let i = 0; i < slides.length; i++) {
                const slide = slides.eq(i);
                const progress = slides[i].progress;
                slide.transform("scale(" + (1 - Math.abs(progress) / 6) + ")");
              }
            }}
            onSetTranslate={(swiper, translate) => {
              const slides = swiper.slides as any;
              for (let i = 0; i < slides.length; i++) {
                const slide = slides.eq(i);
                const progress = slides[i].progress;
                slide.transform("scale(" + (1 - Math.abs(progress) / 6) + ")");
              }
            }}
            onSetTransition={(swiper, transition) => {
              const slides = swiper.slides as any;

              for (var i = 0; i < slides.length; i++) {
                var slide = slides.eq(i);
                slide.transition(transition);
              }
            }}
          >
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock2Product1} alt="product-1" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock2Product2} alt="product-2" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock2Product3} alt="product-3" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock2Product4} alt="product-4" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="block block-3">
          <img src={ImageBlock3Bg} alt="block3" />
        </div>

        <div className="block block-4">
          <h3 className="title">悦享洗护黑科技</h3>
          <Swiper slidesPerView={3} spaceBetween={30}>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock4Bg1} alt="bg-1" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock4Bg2} alt="bg-2" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="content">
                <img src={ImageBlock4Bg3} alt="bg-3" />
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

        <div className="block block-5">
          <img src={ImageBlock5Bg} alt="block2" />
        </div>
        <div className="block block-6">
          <img src={ImageBlock6Bg} alt="block3" />
        </div>
        <div className="block block-7">
          <h3 className="title">家居七步全护方案</h3>
          <img src={ImageBlock7Bg} alt="block4" />
        </div>
      </div>
    </div>
  );
};

export const homeRoute = {
  path: "",
  childRoutes: [{ path: "home", component: HomePage, isIndex: true }],
};
